"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLawData = exports.Timing = void 0;
const std = __importStar(require("../law/std"));
const analyzer = __importStar(require("../analyzer"));
const util = __importStar(require("../util"));
const lawtext_1 = require("../parser/lawtext");
const elawsApi_1 = require("../elawsApi");
const xmlToEL_1 = require("../node/el/xmlToEL");
const getLawList_1 = require("../law/getLawList");
class Timing {
    searchLawID = null;
    fetchStoredLawInfo = null;
    loadData = null;
    extractPict = null;
    parseXMLOrLawtext = null;
    addControlTags = null;
    analyze = null;
    updateComponents = null;
    toString() {
        return `
Timing {
    searchLawID: ${this.searchLawID} ms,
    fetchStoredLawInfo: ${this.fetchStoredLawInfo} ms,
    loadData: ${this.loadData} ms,
    extractPict: ${this.extractPict} ms,
    parseXMLOrLawtext: ${this.parseXMLOrLawtext} ms,
    addControlTags: ${this.addControlTags} ms,
    analyze: ${this.analyze} ms,
    updateComponents: ${this.updateComponents} ms,
}
`.trim();
    }
}
exports.Timing = Timing;
function* findFig(el) {
    if (std.isFig(el)) {
        yield el;
    }
    for (const child of el.children) {
        if (typeof child === "string")
            continue;
        yield* findFig(child);
    }
}
const toLawData = async (props, onMessage, timing) => {
    const _props = props;
    try {
        if ("xml" in _props) {
            onMessage("法令XMLをパースしています...");
            // console.log("toLawData: parsing law xml...");
            await util.wait(30);
            const [parseXMLOrLawtextTime, el] = await util.withTime(xmlToEL_1.xmlToEL)(_props.xml);
            timing.parseXMLOrLawtext = parseXMLOrLawtextTime;
            onMessage("法令名一覧を取得しています...");
            void await (0, getLawList_1.getLawList)();
            onMessage("法令を解析しています...");
            // console.log("onNavigated: analysing law...");
            await util.wait(30);
            const [analyzeTime, analysis] = await util.withTime(analyzer.analyze)({ elToBeModified: el });
            timing.analyze = analyzeTime;
            const pictURL = new Map();
            const lawXMLStruct = _props.lawXMLStruct;
            if (lawXMLStruct) {
                onMessage("画像情報を読み込んでいます...");
                await util.wait(30);
                const start = new Date();
                if (lawXMLStruct instanceof elawsApi_1.ElawsLawData) {
                    const pict = await lawXMLStruct.ensurePict();
                    if (pict) {
                        for (const [src] of pict.entries()) {
                            const url = await lawXMLStruct.getPictFileOrBlobURL(src);
                            if (url)
                                pictURL.set(src, url);
                        }
                    }
                }
                else {
                    for (const fig of findFig(el)) {
                        const src = fig.attr.src;
                        if (!src)
                            continue;
                        const url = await lawXMLStruct.getPictFileOrBlobURL(src);
                        if (url)
                            pictURL.set(src, url);
                    }
                }
                timing.extractPict = (new Date()).getTime() - start.getTime();
            }
            return {
                ok: true,
                lawData: {
                    ..._props,
                    el: el,
                    analysis,
                    pictURL,
                },
            };
        }
        else if ("lawtext" in _props) {
            onMessage("Lawtextをパースしています...");
            // console.log("onNavigated: parsing lawtext...");
            await util.wait(30);
            const [parseXMLOrLawtextTime, { value: el, errors }] = await util.withTime(lawtext_1.parse)(_props.lawtext);
            timing.parseXMLOrLawtext = parseXMLOrLawtextTime;
            onMessage("法令を解析しています...");
            // console.log("onNavigated: analysing law...");
            await util.wait(30);
            const [analyzeTime, analysis] = await util.withTime(analyzer.analyze)({ elToBeModified: el });
            timing.analyze = analyzeTime;
            return {
                ok: true,
                lawData: {
                    ..._props,
                    el: el,
                    analysis,
                    pictURL: new Map(),
                },
                lawtextErrors: errors,
            };
        }
        else {
            throw util.assertNever(_props);
        }
    }
    catch (origError) {
        const error = new Error(`読み込んだ法令データにエラーがあります: ${origError}`);
        error.stack = `${error.stack}
    Original Error:
    ${origError.stack}
    `;
        return {
            ok: false,
            error,
        };
    }
};
exports.toLawData = toLawData;
//# sourceMappingURL=lawdata.js.map